import store from "../redux/store";
import { baseApi } from "../redux/baseAPI";
import { toast } from "react-toastify";
import { isLoggedInUser, isPatientChatMessage } from "../helpers/utility";

let sessionExpiredDebounceTimer = null;

const baseApiHelper = () => {

  const authData = JSON.parse(localStorage.getItem('auth'));

  const isLoggedInUserInMentions = (mentions, loggedInUserId) => {
    if (!mentions || loggedInUserId == null) return false;

    if (!Array.isArray(mentions)) return false;
    return mentions.some((m) => String(m?.id) === String(loggedInUserId));
  };

  const updatePatientChatCacheThroughPusher = (data, locations) => {
    
    if(!isPatientChatMessage(data)){
      return;
    }
    
    store.dispatch(baseApi.util.updateQueryData('getRecentChats', {location_id: locations}, (recentsChats) => {
      
      if(data.type == "patient_location_changed"){
        const foundPatientChatIndex = recentsChats.data.findIndex((item)=> item.pid == data.pid && item.location.id == data.old_location);
        if(foundPatientChatIndex > -1){
          // remove the chat thread if the location is not found in the practice locations
          recentsChats.data.splice(foundPatientChatIndex, 1);
        }
      }
      else{
        const foundChatIndex = recentsChats.data.findIndex((item)=> item.pid == data.pid);
        if(isLoggedInUser(authData, data) && foundChatIndex > -1){
          // Don't move chat to top on chat click
          if(!data.isChatThreadClicked){
            chatThreadonTop(recentsChats.data, foundChatIndex, data);
          }
        }
        else if(!isLoggedInUser(authData, data)){
          if(foundChatIndex > -1){
            if(data.isMsgFromDifferentThread){
              data.unread_urgent_count = data.urgent ? (recentsChats.data[foundChatIndex].unread_urgent_count || 0) + 1 : recentsChats.data[foundChatIndex].unread_urgent_count || 0;
              const mentionedLoggedInUser = isLoggedInUserInMentions(data.mentions, authData?.id);
              data.unread_mention_count = mentionedLoggedInUser ? (recentsChats.data[foundChatIndex].unread_mention_count || 0) + 1 : recentsChats.data[foundChatIndex].unread_mention_count || 0;
              data.unread_message_count = (recentsChats.data[foundChatIndex].unread_message_count || 0) + 1;
              delete data.isMsgFromDifferentThread;
              chatThreadonTop(recentsChats.data, foundChatIndex, data);
            }
            else{
              // making changes in the chat thread while keeping at the same position if message from logined in user
              recentsChats.data[foundChatIndex] = mergePatientChatPreservingTags(recentsChats.data[foundChatIndex], data);
            }
          }
          else{
            let unread_message_count = 0;
            let unread_urgent_count = 0;
            let unread_mention_count = 0;
            if(data.isMsgFromDifferentThread){
              delete data.isMsgFromDifferentThread;
              unread_message_count = 1;
              const mentionedLoggedInUser = isLoggedInUserInMentions(data.mentions, authData?.id);
              if(data.urgent){
                unread_urgent_count = 1;
              }
              if(mentionedLoggedInUser){
                unread_mention_count = 1;
              }
            }
            recentsChats.data.unshift({...data, unread_message_count, unread_urgent_count, unread_mention_count});
          }
        }
      }
      dedupePatientChatThreads(recentsChats.data);
    }));
    
    // Invalidate unread count when new messages are received
    store.dispatch(baseApi.util.invalidateTags(["UnreadMessageCount"]));
  }

  const updateLocationChatCacheThroughPusher = (data, locations) => {

    if(isPatientChatMessage(data)){
      return;
    }

    store.dispatch(baseApi.util.updateQueryData('getLocationChats', {location_id: locations}, (recentsChats) => {

      const foundChatIndex = recentsChats.data.findIndex((item)=> item.location.id == data.location.id);
      if(foundChatIndex > -1){
        data.location = recentsChats.data[foundChatIndex].location;
      }
      
      if(isLoggedInUser(authData, data) && foundChatIndex > -1){
        if(data.isChatThreadClicked || !data.isMsgFromDifferentThread){
          recentsChats.data[foundChatIndex] = {...recentsChats.data[foundChatIndex], ...data};
        }
        else if(!data.isChatThreadClicked){ // Don't move chat to top on chat click
          data.unread_message_count = (recentsChats.data[foundChatIndex].unread_message_count || 0) + 1;
          chatThreadonTop(recentsChats.data, foundChatIndex, data);
        }
      }
      else if(!isLoggedInUser(authData, data)){
        if(foundChatIndex > -1){
          if(data.isMsgFromDifferentThread){
            data.unread_message_count = (recentsChats.data[foundChatIndex].unread_message_count || 0) + 1;
            data.unread_urgent_count = data.urgent ? (recentsChats.data[foundChatIndex].unread_urgent_count || 0) + 1 : recentsChats.data[foundChatIndex].unread_urgent_count || 0;
            const mentionedLoggedInUser = isLoggedInUserInMentions(data.mentions, authData?.id);
            data.unread_mention_count = mentionedLoggedInUser ? (recentsChats.data[foundChatIndex].unread_mention_count || 0) + 1 : recentsChats.data[foundChatIndex].unread_mention_count || 0;
            delete data.isMsgFromDifferentThread;
            chatThreadonTop(recentsChats.data, foundChatIndex, data);
          }
          else{
            // making changes in the chat thread while keeping at the same position if message from logined in user
            recentsChats.data[foundChatIndex] = {...recentsChats.data[foundChatIndex], ...data};
          }
        }
        else{
          let unread_message_count = 0;
          if(data.isMsgFromDifferentThread){
            delete data.isMsgFromDifferentThread;
            unread_message_count = 1;
          }
          recentsChats.data.unshift({...data, unread_message_count});
        }
      }
    }));
    
    // Invalidate unread count when new messages are received
    store.dispatch(baseApi.util.invalidateTags(["UnreadMessageCount"]));
  }

  // const updatePatientChatsCacheThroughPusher = (data) => {
  //   const { pid, user, user_type, nurse_id, user_id, message_id } = data;
  //   const { id: auth_id } = authData;
  
  //   store.dispatch(baseApi.util.updateQueryData('getPatientChats', { pid }, (patientChats) => {
  //     try {
  //         const foundMsgIndex = patientChats.data.findIndex((msg) => `${msg.id}` === `${message_id}`);
  //         if (foundMsgIndex > -1) {
  //           patientChats.data[foundMsgIndex] = {
  //             ...patientChats.data[foundMsgIndex],
  //             ...data,
  //             acknowledged_by_user_id: data.user,
  //           };
  //           const parsedData = JSON.parse(JSON.stringify(patientChats.data));
  //         } else {
  //           console.warn(`Message with id ${msg_id} not found in patient chats.`);
  //         }
  //     } catch (error) {
  //       console.error('Error updating patientChats data:', error);
  //     }
  //   }));
  // }

  const mergePatientChatPreservingTags = (existingChat, incomingData) => {
    const merged = { ...existingChat, ...incomingData };
    const hasExistingTags = existingChat.patient?.patient_group_color != null &&
      (Array.isArray(existingChat.patient.patient_group_color) ? existingChat.patient.patient_group_color.length > 0 : true);
    const incomingHasNoTags = incomingData.patient?.patient_group_color == null ||
      (Array.isArray(incomingData.patient?.patient_group_color) && incomingData.patient.patient_group_color.length === 0);
    if (merged.patient && hasExistingTags && incomingHasNoTags) {
      merged.patient = { ...merged.patient, patient_group_color: existingChat.patient.patient_group_color };
    }
    return merged;
  };
  
  const chatThreadonTop = (recentsChats, index, data) => {
    // bring the chat thread on top if msg received from different user
    const updatedMsg = mergePatientChatPreservingTags(recentsChats[index], data);
    recentsChats.splice(index, 1);
    recentsChats.unshift(updatedMsg);
  }

  const dedupePatientChatThreads = (recentsChats) => {
    const seenChatKeys = new Set();
    for (let index = 0; index < recentsChats.length; index += 1) {
      const chatKey = recentsChats[index]?.pid || recentsChats[index]?.chat_id || recentsChats[index]?.id;
      if (!chatKey) {
        continue;
      }
      if (seenChatKeys.has(chatKey)) {
        recentsChats.splice(index, 1);
        index -= 1;
        continue;
      }
      seenChatKeys.add(chatKey);
    }
  }

  const updateChatMessageCacheThroughPusher = (data) => {
    store.dispatch(baseApi.util.updateQueryData('getPatientChats', {pid: data.pid, limit: 50, page: 1}, (patientChats) => {
      patientChats.data.unshift(data);
    }))
  }

  const invalidateTags = (tagsToInvalidate) => {
    if(tagsToInvalidate && tagsToInvalidate.length > 0) {
      store.dispatch(baseApi.util.invalidateTags(tagsToInvalidate));
    }
  }

  const invalidateThroughSocket = (receivedComponent, extraData, updateLocalData) => {
    store.dispatch((dispatch, getState) => {
      switch (receivedComponent) {
        case 'labs':
          invalidateTags(['Result', 'labOrder', 'LabOrdersInNote', 'LabPendingOrders', 'LabAwaitingResults', 'LabFutureOrders']);
          localDocumateRTKStateOverwrite(updateLocalData, ['DocumateLabsList']);
          if (extraData) {
            /// do something with your extraData, if sent
          }
        break;
      }
    });
  }

  const localDocumateRTKStateOverwrite = (dataToOverwrite, rtkQueryMethods) => {
    invalidateTags(rtkQueryMethods);
  }

  const responseErrorCheck = (response) => {
    if ((response?.code === -1 || response?.code === '-1') && response?.msg?.toLowerCase()?.includes("session has expired")) {
      if (sessionExpiredDebounceTimer) {
        clearTimeout(sessionExpiredDebounceTimer);
      }
      sessionExpiredDebounceTimer = setTimeout(() => {
        toast.error(response?.msg);
      }, 1500);
    }
    else if ((response?.code === -1 || response?.code === '-1') && response?.msg && response?.msg?.length > 0) {
      toast.error(response?.msg);
    } else if (typeof response?.code == 'undefined') {
      toast.error("Something went wrong, please try again later.");
    }
  }

  return {
    updatePatientChatCacheThroughPusher: updatePatientChatCacheThroughPusher,
    updateLocationChatCacheThroughPusher: updateLocationChatCacheThroughPusher,
    updateChatMessageCacheThroughPusher: updateChatMessageCacheThroughPusher,
    invalidateTags: invalidateTags,
    invalidateThroughSocket: invalidateThroughSocket,
    localDocumateRTKStateOverwrite: localDocumateRTKStateOverwrite,
    responseErrorCheck: responseErrorCheck,
    // updatePatientChatsCacheThroughPusher: updatePatientChatsCacheThroughPusher
  };
}

export default baseApiHelper;